import { useCallback } from 'react';
import { ErrorService, type ErrorOptions } from '../services/errorService';

export function useErrorHandler() {
  const handleError = useCallback((error: unknown, options?: ErrorOptions) => {
    return ErrorService.handle(error, options);
  }, []);

  const handleAsyncError = useCallback(
    async <T>(promise: Promise<T>, options?: ErrorOptions): Promise<T | null> => {
      return ErrorService.handleAsync(promise, options);
    },
    []
  );

  return { handleError, handleAsyncError };
}